/**
 * Application route constants for type-safe navigation
 */
export class AppRoutes {
  static readonly Dashboard = 'dashboard';
  static readonly Error = 'error';
  static readonly UnauthorizedQualifiers = 'unauthorized-qualifiers';
  static readonly AlertsDetails = 'alertsdetails';
  static readonly PayInfo = 'payinfo';
  static readonly StaleDatedChecksInfo = 'staledatedchecksinfo';
  static readonly ViewCompanies = 'viewcompanies';
  static readonly PrenoteHistory = 'prenotehistory';
  static readonly Auth = '';
  static readonly Callback = 'callback';
  static readonly Logout = 'logout';
}
